import axios from 'axios'
import { reportDataSetService } from '../report-data-set.service'
import { TABLE_SPECIFIC_DATA_FIELDS } from './table-edit.constants'

class TableEditService {
  async validateAndCompleteConfig (blockConfig, reportId) {
    return axios.post(`api/report/${reportId}/block-config`, blockConfig)
  }

  getVariableOptions (page, dataKey) {
    const options = reportDataSetService.getDataFieldOptions(page, dataKey)
    return options.filter(({ value }) => !TABLE_SPECIFIC_DATA_FIELDS.includes(value))
  }

  isEmpty (value) {
    return value === undefined || value === null || value === ''
  }
}

export const tableEditService = new TableEditService()
